import api from './api';

export const quotaService = {
    async getQuotaStatus() {
        const response = await api.get('/api-key/status');
        // Backend returns: { configured, updated_at, requests_today?, daily_limit?, per_minute_limit? }
        return response.data;
    },
};
